import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export function getDatadogConfig() {
  const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
  const site = process.env.REACT_APP_DATADOG_SITE;
  const service = process.env.REACT_APP_DATADOG_SERVICE || 'slds-mockups';
  const env = process.env.REACT_APP_DATADOG_ENV || 'production';

  if (!applicationId || !clientToken || !site) {
    return null;
  }

  return {
    applicationId,
    clientToken,
    site,
    service,
    env,
  };
}

export function initDatadogRum() {
  // Only initialize in production environment
  if (process.env.NODE_ENV === 'development') {
    console.log('Datadog RUM disabled in development environment');
    return false;
  }

  const config = getDatadogConfig();

  if (!config) {
    console.warn('Datadog RUM not initialized: Missing configuration');
    return false;
  }

  try {
    datadogRum.init({
      applicationId: config.applicationId,
      clientToken: config.clientToken,
      site: config.site,
      service: config.service,
      env: config.env,
      version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: false })],
    });

    console.log('Datadog RUM initialized successfully', {
      service: config.service,
      env: config.env,
      site: config.site,
    });

    return true;
  } catch (error) {
    console.error('Failed to initialize Datadog RUM:', error);
    return false;
  }
}
